"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHttp = useHttp;
var _react = require("react");
var _axios = _interopRequireDefault(require("../util/axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function useHttp(_ref) {
  let {
    endpoint,
    connector = _axios.default,
    method = 'get',
    config = {}
  } = _ref;
  const [loading, setLoading] = (0, _react.useState)(true);
  const [data, setData] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    connector[method.toLowerCase()](endpoint, config).then(res => {
      setData(res.data);
      setLoading(false);
    }).catch(err => {
      if (err && err.response && err.response.data) {
        setData(err.response.data);
      }
      setError(err);
      setLoading(false);
    });
  }, [endpoint, connector]);
  return {
    data,
    error,
    loading
  };
}
//# sourceMappingURL=use-http.js.map